import { JSX } from "react"
import MbrAprvMng from "../base/mbr/MbrAprvMng";
import MbrMng from "../base/mbr/MbrMng";
import MbrasWhdwlMng from "../base/mbras/MbrasWhdwlMng";
import MbrasExistingMng from "../base/mbras/MbrasExistingMng";
import MbrasNewMng from "../base/mbras/MbrasNewMng";
import MbrasAtrzRtso from "../base/mbras/MbrasAtrzRtso";
import MbrasAtrzPrgrsinq from "../base/mbras/MbrasAtrzPrgrsinq";
import Mbrasinq from "../base/mbras/Mbrasinq";
import BgtMbsdsBgtFrmt from "../base/bgtmbsds/BgtMbsdsBgtFrmt";
import BgtMbsdsDpstMng from "../base/bgtmbsds/BgtMbsdsDpstMng";
import BgtMbsdsExpndRsdocMng from "../base/bgtmbsds/BgtMbsdsExpndRsdocMng";
import BgtMbsdsAtrzRtso from "../base/bgtmbsds/BgtMbsdsAtrzRtso";
import BgtMbsdsDpstimplinq from "../base/bgtmbsds/BgtMbsdsDpstimplinq";
import BgtMbsdsWholinq from "../base/bgtmbsds/BgtMbsdsWholinq";
import SysBgtSbjctMng from "../base/sys/SysBgtSbjctMng";
import SysOgnzMng from "../base/sys/SysOgnzMng";
import SysSpcBgtSbjctMng from "../base/sys/SysSpcBgtSbjctMng";
import SysOgnzInq from "../base/sys/SysOgnzInq";
import SysAprvrMng2 from "../base/sys/SysAprvrMng2";
import BgtOvrlDpstMng from "../base/bgtovrl/BgtOvrlDpstMng";
import BgtOvrlExpndRsdocMng from "../base/bgtovrl/BgtOvrlExpndRsdocMng";
import BgtOvrlAtrzRtso from "../base/bgtovrl/BgtOvrlAtrzRtso";
import BgtOvrlDpstImplInq from "../base/bgtovrl/BgtOvrlDpstImplInq";
import BgtOvrlWholInq from "../base/bgtovrl/BgtOvrlWholInq";
import BgtSpcBgtFrmt from "../base/bgtspc/BgtSpcBgtFrmt";
import BgtSpcDpstMng from "../base/bgtspc/BgtSpcDpstMng";
import BgtSpcExpndRsdocMng from "../base/bgtspc/BgtSpcExpndRsdocMng";
import BgtSpcAtrzRtso from "../base/bgtspc/BgtSpcAtrzRtso";
import BgtSpcWholinq from "../base/bgtspc/BgtSpcWholInq";
import AtrzDocPrcsMng from "../base/atrz/AtrzDocPrcsMng";
import StatsAcntgYrIncmExpndInq from "../base/stats/StatsAcntgYrIncmExpndInq";
import StatsAcntgYrUseAmtInq from "../base/stats/StatsAcntgYrUseAmtInq";
import BgtSpcDpstImplInq from "../base/bgtspc/BgtSpcDpstImplInq";
import BgtSpcExpndSubRsdocMng from "../base/bgtspc/BgtSpcExpndSubRsdocMng";
import SysAcntgYearMng from "../base/sys/SysAcntgYearMng";
import SysOgnzAuthrtMng from "../base/sys/SysOgnzAuthrtMng";
import BgtMbsdsExpndSubRsdocMng from "../base/bgtmbsds/BgtMbsdsExpndSubRsdocMng";
import StatsOvrlMbsdsMonUpOgnzGrnamtInq from "../base/stats/StatsOvrlMbsdsMonUpOgnzGrnamtInq";
import StatsSpcAcntgYrIncmExpndInq from "../base/stats/StatsSpcAcntgYrIncmExpndInq";
import StatsOvrlMbsdsMonGrnamtInq from "../base/stats/StatsOvrlMbsdsMonGrnamtInq";
import BgtMbsdsAtrzPrgrsInq from "../base/bgtmbsds/BgtMbsdsAtrzPrgrsInq";
import BgtSpcAllImplInq from "../base/bgtspc/BgtSpcAllImplInq";
import BgtSpcAllAtrzPrgrsInq from "../base/bgtspc/BgtSpcAllAtrzPrgrsInq";
import BgtOvrlAtrzPrgrsInq from "../base/bgtovrl/BgtOvrlAtrzPrgrsInq";
import StatsOvrlMbsdsGrnamtInq from "../base/stats/StatsOvrlMbsdsGrnamtInq";
import BgtBrDpstMng from "../base/bgtbr/BgtBrDpstMng";
import BgtBrExpndRsdocMng from "../base/bgtbr/BgtBrExpndRsdocMng";
import BgtBrExpndSubRsdocMng from "../base/bgtbr/BgtBrExpndSubRsdocMng";
import BgtBrAtrzRtso from "../base/bgtbr/BgtBrAtrzRtso";
import BgtBrDpstImplInq from "../base/bgtbr/BgtBrDpstImplInq";
import BgtBrAllAtrzPrgrsInq from "../base/bgtbr/BgtBrAllAtrzPrgrsInq";
import BgtBrWholInq from "../base/bgtbr/BgtBrWholInq";
import CashBookMng from "../base/stats/CashBookMng";
import CashExpenseBookMng from "../base/stats/CashExpenseBookMng";
import BgtCmptnAttachMng from "../base/sys/BgtCmptnAttachMng";
import MbrasChangeMng from "../base/mbras/MbrasChangeMng";
import MbrasPeriodStats from "../base/mbras/stats/MbrasPeriodStats";
import SysMbrasAprvrMng from "../base/sys/SysMbrasAprvrMng";

interface systemSubMenuProps {
    url: string
    name: string
    el: JSX.Element
    isVisible: boolean
    headOfficeOnly?: boolean
    detailMenuList?: systemSubMenuProps[]
}
interface systemMenuProps {
    url: string
    name: string
    iconClass: string
    allowedRoles: string[]; // 사용자 권한 배열
    allowedSystem: string[]; // 사용 시스템 배열
    allowedSubSystem: string[]; // 결재자 조회용 서브 시스템 배열
    targetSystem?: string; // 결재자 통계의 선택 시스템
    subMenuList: systemSubMenuProps[]
    isVisible: boolean
}
const SystemMenu = {
    menuList: [
        // 조합비 관리자 + 본부 관리자 메뉴 : 회원관리, 총괄 교부금, 시스템 관리
        // 조합비 관리자 메뉴               : 총괄 교부금, 시스템 관리
        // 조합비 조회자 메뉴               : 총괄 교부금 조회

        // 1. 총괄 교부금(A1)
        // 1.1 총괄 교부금(A1) - 회원관리
        {
            url: "/system/A1mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["A1"],
            allowedSubSystem: ["A"],
            subMenuList: [
                { url: "/system/A1mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/A1mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 1.2 총괄 교부금(A1) - 총괄 교부금
        {
            url: "/system/A1bgtovrldpstmng",
            name: "총괄 교부금",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["A1"],
            allowedSubSystem: ["A"],
            subMenuList: [
                { url: "/system/A1bgtovrldpstmng"      , name: "교부금 수입"  , el: <BgtOvrlDpstMng       />, isVisible: true },
                { url: "/system/A1bgtovrlexpndrsdocmng", name: "교부금 지출"  , el: <BgtOvrlExpndRsdocMng />, isVisible: true },
                { url: "/system/A1bgtovrlatrzrtso"     , name: "결재 상신"    , el: <BgtOvrlAtrzRtso      />, isVisible: true },
                { url: "/system/A1bgtovrlwholinq"      , name: "전체 조회"    , el: <BgtOvrlWholInq       />, isVisible: true },
                { url: "/system/A1bgtovrldpstimplinq"  , name: "결재완료 조회", el: <BgtOvrlDpstImplInq   />, isVisible: true },
            ]
        },
        // 1.3 총괄 교부금(A1) - 통계
        {
            url: "/system/A1statsovrlmbsdsmonupognzgrnamtinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["A1"],
            allowedSubSystem: ["A"],
            subMenuList: [
                { url: "/system/A1statsovrlmbsdsmonupognzgrnamtinq", name: "지방본부별 교부금"     , el: <StatsOvrlMbsdsMonUpOgnzGrnamtInq />, isVisible: true },
                { url: "/system/A1statsovrlmbsdsmongrnamtinq"      , name: "월별 전체 교부금"      , el: <StatsOvrlMbsdsMonGrnamtInq       />, isVisible: true },
                { url: "/system/A1statsovrlmbsdsgrnamtinq"         , name: "월별/지방본부별 교부금", el: <StatsOvrlMbsdsGrnamtInq          />, isVisible: true },
            ]
        },
        // 1.4 총괄 교부금(A1) - 조합비 결재자 관리
        {
            url: "/system/A1sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["A1"],
            allowedSubSystem: ["A"],
            subMenuList: [
                { url: "/system/A1sysaprvrmng2", name: "조합비 결재자 관리", el: <SysAprvrMng2 />, isVisible: true },
            ]
        },
        // 1.5 총괄 교부금(A1) - 총괄 교부금 조회
        {
            url: "/system/A1bgtovrldpstimplinq/view",
            name: "총괄 교부금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["A1"],
            allowedSubSystem: ["A"],
            subMenuList: [
                { url: "/system/A1bgtovrldpstimplinq/view", name: "결재완료 조회", el: <BgtOvrlDpstImplInq />, isVisible: true },
            ]
        },
        // 1.6 총괄 교부금(A1) - 시스템 관리자
        {
            url: "/system/A1sysognzmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["A1"],
            allowedSubSystem: ["A"],
            subMenuList: [
                { url: "/system/A1sysognzmng/mng"       , name: "본부 및 지부 관리"    , el: <SysOgnzMng        />, isVisible: true },
                { url: "/system/A1sysognzinq/mng"       , name: "본부 및 지부 조회"    , el: <SysOgnzInq        />, isVisible: true },
                { url: "/system/A1sysaprvrmng2/mng"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
                { url: "/system/A1sysacntgyearmng/mng"  , name: "회계연도 관리"        , el: <SysAcntgYearMng   />, isVisible: true },
                { url: "/system/A1sysognzauthrtmng/mng" , name: "조직시스템 권한 관리" , el: <SysOgnzAuthrtMng  />, isVisible: true },
            ]
        },

        // 조합비 관리자 + 본부 관리자 메뉴 : 회원관리, 운영비, 시스템 관리
        // 조합비 관리자 메뉴               : 운영비, 시스템 관리
        // 조합비 조회자 메뉴               : 운영비 조회
        // 2. 운영비(B1)
        // 2.1 운영비(B1) - 회원관리
        {
            url: "/system/B1mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["B1"],
            allowedSubSystem: ["B"],
            subMenuList: [
                { url: "/system/B1mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/B1mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 2.2 운영비(B1) - 운영비
        {
            url: "/system/B1bgtmbsdsbgtfrmt",
            name: "운영비 관리",
            iconClass: "icon5",
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["B1"],
            allowedSubSystem: ["B"],
            isVisible: true,
            subMenuList: [
                { url: "/system/B1bgtmbsdsbgtfrmt"         , name: "예산 편성"         , el: <BgtMbsdsBgtFrmt          />, isVisible: true },
                { url: "/system/B1bgtmbsdsdpstmng"         , name: "수입 결의서"       , el: <BgtMbsdsDpstMng          />, isVisible: true },
                { url: "/system/B1bgtmbsdsexpndrsdocmng"   , name: "지출 결의서"       , el: <BgtMbsdsExpndRsdocMng    />, isVisible: true },
                { url: "/system/B1BgtMbsdsExpndSubRsdocMng", name: "여입/추가 자료제출", el: <BgtMbsdsExpndSubRsdocMng />, isVisible: true },
                { url: "/system/B1bgtmbsdsatrzrtso"        , name: "결재 상신"         , el: <BgtMbsdsAtrzRtso         />, isVisible: true },
                { url: "/system/B1bgtmbsdswholinq"         , name: "전체 조회"         , el: <BgtMbsdsWholinq          />, isVisible: true },
                { url: "/system/B1bgtmbsdsdpstimplinq"     , name: "결재완료 조회"     , el: <BgtMbsdsDpstimplinq      />, isVisible: true },
            ]
        },
        // 2.4 운영비(B1) - 통계
        {
            url: "/system/B1statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["B1"],
            allowedSubSystem: ["B"],
            subMenuList: [
                { url: "/system/B1statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsAcntgYrIncmExpndInq />, isVisible: true },
                { url: "/system/B1statsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="01"/>, isVisible: true },
                { url: "/system/B1cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              />, isVisible: true },
                { url: "/system/B1cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       />, isVisible: true },
            ]
        },
        // 2.4 운영비(B1) - 총괄 교부금 통계
        {
            url: "/system/B1statsovrlmbsdsmonupognzgrnamtinq",
            name: "총괄 교부금 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["B1"],
            allowedSubSystem: ["B"],
            subMenuList: [
                { url: "/system/B1statsovrlmbsdsmonupognzgrnamtinq", name: "지방본부별 교부금"     , el: <StatsOvrlMbsdsMonUpOgnzGrnamtInq />, isVisible: true },
                { url: "/system/B1statsovrlmbsdsmongrnamtinq"      , name: "월별 전체 교부금"      , el: <StatsOvrlMbsdsMonGrnamtInq       />, isVisible: true },
                { url: "/system/B1statsovrlmbsdsgrnamtinq"         , name: "월별/지방본부별 교부금", el: <StatsOvrlMbsdsGrnamtInq          />, isVisible: true },
            ]
        },
        // 2.3 운영비(B1) - 조합비 결재자 관리
        {
            url: "/system/B1sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["B1"],
            allowedSubSystem: ["B"],
            subMenuList: [
                { url: "/system/B1sysaprvrmng2"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
            ]
        },
        // 2.5 운영비(B1) - 운영비 조회: 조회자
        {
            url: "/system/B1bgtmbsdsdpstimplinq/view",
            name: "운영비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["B1"],
            allowedSubSystem: ["B"],
            subMenuList: [
                { url: "/system/B1bgtmbsdsdpstimplinq/view" , name: "결재완료 조회", el: <BgtMbsdsDpstimplinq  />, isVisible: true },
            ]
        },
        // 2.6 운영비(B1) - 시스템관리자
        {
            url: "/system/B1sysbgtsbjctmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["B1"],
            allowedSubSystem: ["B"],
            subMenuList: [
                { url: "/system/B1sysbgtsbjctmng/mng"  , name: "운영비 예산과목 관리", el: <SysBgtSbjctMng   />, isVisible: true },
                { url: "/system/B1sysognzmng/mng"      , name: "본부 및 지부 관리"   , el: <SysOgnzMng       />, isVisible: true },
                { url: "/system/B1sysognzinq/mng"      , name: "본부 및 지부 조회"   , el: <SysOgnzInq       />, isVisible: true },
                { url: "/system/B1sysaprvrmng2/mng"    , name: "조합비 결재자 관리"  , el: <SysAprvrMng2     />, isVisible: true },
                { url: "/system/B1sysacntgyearmng/mng" , name: "회계연도 관리"       , el: <SysAcntgYearMng  />, isVisible: true },
                { url: "/system/B1sysognzauthrtmng/mng", name: "조직시스템 권한 관리", el: <SysOgnzAuthrtMng />, isVisible: true },
                { url: "/system/B1bgtcmptnattachmng/mng",name: "결재완료 결의서 첨부관리", el: <BgtCmptnAttachMng  />, isVisible: true },
            ]
        },

        // 조합비 관리자 + 본부 관리자 메뉴 : 회원관리, 복지기금, 시스템 관리
        // 조합비 관리자 메뉴               : 복지기금, 시스템 관리
        // 조합비 조회자 메뉴               : 복지기금 조회
        // 3. 복지기금(C1)
        // 3.1 복지기금(C1) - 회원관리
        {
            url: "/system/C1mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["C1"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C1mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/C1mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 3.1 복지기금(C1) - 복지기금
        {
            url: "/system/C1bgtspcbgtfrmt",
            name: "복지기금 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C1"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C1bgtspcbgtfrmt"         , name: "예산 편성"         , el: <BgtSpcBgtFrmt          systemCode="C1" />, isVisible: true },
                { url: "/system/C1bgtspcdpstmng"         , name: "수입 결의서"       , el: <BgtSpcDpstMng          systemCode="C1" />, isVisible: true },
                { url: "/system/C1bgtspcexpndrsdocmng"   , name: "지출 결의서"       , el: <BgtSpcExpndRsdocMng    systemCode="C1" />, isVisible: true },
                { url: "/system/C1bgtspcexpndsubrsdocmng", name: "여입/추가 자료제출", el: <BgtSpcExpndSubRsdocMng systemCode="C1" />, isVisible: true },
                { url: "/system/C1bgtspcatrzrtso"        , name: "결재 상신"         , el: <BgtSpcAtrzRtso         systemCode="C1" />, isVisible: true },
                { url: "/system/C1bgtspcwholinq"         , name: "전체 조회"         , el: <BgtSpcWholinq          systemCode="C1" />, isVisible: true },
                { url: "/system/C1bgtspcdpstimplinq"     , name: "결재완료 조회"     , el: <BgtSpcDpstImplInq      systemCode="C1" />, isVisible: true },
            ]
        },
        // 3.3 복지기금(C1) - 통계
        {
            url: "/system/C1statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C1"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C1statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C1"/>, isVisible: true },
                { url: "/system/C1statsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C1"/>, isVisible: true },
                { url: "/system/C1cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C1"/>, isVisible: true },
                { url: "/system/C1cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C1"/>, isVisible: true },
            ]
        },
        // 3.4 복지기금(C1) - 조합비 결재자 관리
        {
            url: "/system/C1sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["C1"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C1sysaprvrmng2"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
            ]
        },
        // 3.5 복지기금(C1) - 복지기금 조회
        {
            url: "/system/C1bgtspcdpstimplinq/view",
            name: "복지기금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["C1"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C1bgtspcdpstimplinq/view", name: "결재완료 조회", el: <BgtSpcDpstImplInq systemCode="C1"/>, isVisible: true },
            ]
        },
        // 3.6 복지기금(C1) - 시스템 관리자
        {
            url: "/system/C1sysspcbgtsbjctmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["C1"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C1sysspcbgtsbjctmng/mng", name: "특별회계기금 예산과목", el: <SysSpcBgtSbjctMng />, isVisible: true },
                { url: "/system/C1sysognzmng/mng"       , name: "본부 및 지부 관리"    , el: <SysOgnzMng        />, isVisible: true },
                { url: "/system/C1sysognzinq/mng"       , name: "본부 및 지부 조회"    , el: <SysOgnzInq        />, isVisible: true },
                { url: "/system/C1sysaprvrmng2/mng"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
                { url: "/system/C1sysacntgyearmng/mng"  , name: "회계연도 관리"        , el: <SysAcntgYearMng   />, isVisible: true },
                { url: "/system/C1sysognzauthrtmng/mng" , name: "조직시스템 권한 관리" , el: <SysOgnzAuthrtMng  />, isVisible: true },
            ]
        },

        // 조합비 관리자 + 본부 관리자 메뉴 : 회원관리, 자립기금, 시스템 관리
        // 조합비 관리자 메뉴               : 자립기금, 시스템 관리
        // 조합비 조회자 메뉴               : 자립기금 조회
        // 4. 자립기금(C2)
        // 4.1 자립기금(C2) - 회원관리
        {
            url: "/system/C2mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["C2"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C2mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/C2mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 4.2 자립기금(C2) - 자립기금
        {
            url: "/system/C2bgtspcbgtfrmt",
            name: "자립기금 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C2"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C2bgtspcbgtfrmt"         , name: "예산 편성"         , el: <BgtSpcBgtFrmt          systemCode="C2" />, isVisible: true },
                { url: "/system/C2bgtspcdpstmng"         , name: "수입 결의서"       , el: <BgtSpcDpstMng          systemCode="C2" />, isVisible: true },
                { url: "/system/C2bgtspcexpndrsdocmng"   , name: "지출 결의서"       , el: <BgtSpcExpndRsdocMng    systemCode="C2" />, isVisible: true },
                { url: "/system/C2bgtspcexpndsubrsdocmng", name: "여입/추가 자료제출", el: <BgtSpcExpndSubRsdocMng systemCode="C2" />, isVisible: true },
                { url: "/system/C2bgtspcatrzrtso"        , name: "결재 상신"         , el: <BgtSpcAtrzRtso         systemCode="C2" />, isVisible: true },
                { url: "/system/C2bgtspcwholinq"         , name: "전체 조회"         , el: <BgtSpcWholinq          systemCode="C2" />, isVisible: true },
                { url: "/system/C2bgtspcdpstimplinq"     , name: "결재완료 조회"     , el: <BgtSpcDpstImplInq      systemCode="C2" />, isVisible: true },
            ]
        },
        // 4.3 자립기금(C2) - 통계
        {
            url: "/system/C2statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C2"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C2statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C2"/>, isVisible: true },
                { url: "/system/C2statsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C2"/>, isVisible: true },
                { url: "/system/C2cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C2"/>, isVisible: true },
                { url: "/system/C2cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C2"/>, isVisible: true },
            ]
        },
        // 4.4 자립기금(C2) - 조합비 결재자 관리
        {
            url: "/system/C2sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["C2"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C2sysaprvrmng2", name: "조합비 결재자 관리", el: <SysAprvrMng2 />, isVisible: true },
            ]
        },
        // 4.5 자립기금(C2) - 자립기금 조회
        {
            url: "/system/C2bgtspcdpstimplinq/view",
            name: "자립기금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["C2"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C2bgtspcdpstimplinq/view", name: "결재완료 조회", el: <BgtSpcDpstImplInq systemCode="C2"/>, isVisible: true },
            ]
        },
        // 4.6 자립기금(C2) - 시스템 관리자
        {
            url: "/system/C2sysspcbgtsbjctmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["C2"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C2sysspcbgtsbjctmng/mng", name: "특별회계기금 예산과목", el: <SysSpcBgtSbjctMng />, isVisible: true },
                { url: "/system/C2sysognzmng/mng"       , name: "본부 및 지부 관리"    , el: <SysOgnzMng        />, isVisible: true },
                { url: "/system/C2sysognzinq/mng"       , name: "본부 및 지부 조회"    , el: <SysOgnzInq        />, isVisible: true },
                { url: "/system/C2sysaprvrmng2/mng"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
                { url: "/system/C2sysacntgyearmng/mng"  , name: "회계연도 관리"        , el: <SysAcntgYearMng   />, isVisible: true },
                { url: "/system/C2sysognzauthrtmng/mng" , name: "조직시스템 권한 관리" , el: <SysOgnzAuthrtMng  />, isVisible: true },
            ]
        },

        // 조합비 관리자 + 본부 관리자 메뉴 : 회원관리, 발전기금, 시스템 관리
        // 조합비 관리자 메뉴               : 발전기금, 시스템 관리
        // 조합비 조회자 메뉴               : 발전기금 조회
        // 5. 발전기금(C3)
        // 5.1 발전기금(C3) - 회원관리
        {
            url: "/system/C3mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["C3"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C3mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/C3mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 5.2 발전기금(C3) - 발전기금
        {
            url: "/system/C3bgtspcbgtfrmt",
            name: "발전기금 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C3"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C3bgtspcbgtfrmt"         , name: "예산 편성"         , el: <BgtSpcBgtFrmt          systemCode="C3" />, isVisible: true },
                { url: "/system/C3bgtspcdpstmng"         , name: "수입 결의서"       , el: <BgtSpcDpstMng          systemCode="C3" />, isVisible: true },
                { url: "/system/C3bgtspcexpndrsdocmng"   , name: "지출 결의서"       , el: <BgtSpcExpndRsdocMng    systemCode="C3" />, isVisible: true },
                { url: "/system/C3bgtspcexpndsubrsdocmng", name: "여입/추가 자료제출", el: <BgtSpcExpndSubRsdocMng systemCode="C3" />, isVisible: true },
                { url: "/system/C3bgtspcatrzrtso"        , name: "결재 상신"         , el: <BgtSpcAtrzRtso         systemCode="C3" />, isVisible: true },
                { url: "/system/C3bgtspcwholinq"         , name: "전체 조회"         , el: <BgtSpcWholinq          systemCode="C3" />, isVisible: true },
                { url: "/system/C3bgtspcdpstimplinq"     , name: "결재완료 조회"     , el: <BgtSpcDpstImplInq      systemCode="C3" />, isVisible: true },
            ]
        },
        // 5.3 발전기금(C3) - 통계
        {
            url: "/system/C3statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C3"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C3statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C3" />, isVisible: true },
                { url: "/system/C3statsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C3"/>, isVisible: true },
                { url: "/system/C3cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C3"/>, isVisible: true },
                { url: "/system/C3cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C3"/>, isVisible: true },
            ]
        },
        // 5.4 발전기금(C3) - 조합비 결재자 관리
        {
            url: "/system/C3sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["C3"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C3sysaprvrmng2"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
            ]
        },
        // 5.5 발전기금(C3) - 발전기금 조회
        {
            url: "/system/C3bgtspcdpstimplinq/view",
            name: "발전기금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["C3"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C3bgtspcdpstimplinq/view", name: "결재완료 조회", el: <BgtSpcDpstImplInq systemCode="C3"/>, isVisible: true },
            ]
        },
        // 5.6 발전기금(C3) - 시스템 관리자
        {
            url: "/system/C3sysspcbgtsbjctmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["C3"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C3sysspcbgtsbjctmng/mng", name: "특별회계기금 예산과목", el: <SysSpcBgtSbjctMng />, isVisible: true },
                { url: "/system/C3sysognzmng/mng"       , name: "본부 및 지부 관리"    , el: <SysOgnzMng        />, isVisible: true },
                { url: "/system/C3sysognzinq/mng"       , name: "본부 및 지부 조회"    , el: <SysOgnzInq        />, isVisible: true },
                { url: "/system/C3sysaprvrmng2/mng"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
                { url: "/system/C3sysacntgyearmng/mng"  , name: "회계연도 관리"        , el: <SysAcntgYearMng   />, isVisible: true },
                { url: "/system/C3sysognzauthrtmng/mng" , name: "조직시스템 권한 관리" , el: <SysOgnzAuthrtMng  />, isVisible: true },
            ]
        },
        // 조합비 관리자 + 본부 관리자 메뉴 : 회원관리, 희생자부조금, 시스템 관리
        // 조합비 관리자 메뉴               : 희생자부조금, 시스템 관리
        // 조합비 조회자 메뉴               : 희생자부조금 조회
        // 6. 희생자부조금(C4)
        // 6.1 희생자부조금(C4) - 회원관리
        {
            url: "/system/C4mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["C4"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C4mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/C4mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 6.2 희생자부조금(C4) - 희생자부조금
        {
            url: "/system/C4bgtspcbgtfrmt",
            name: "희생자부조금 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C4"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C4bgtspcbgtfrmt"         , name: "예산 편성"         , el: <BgtSpcBgtFrmt          systemCode="C4" />, isVisible: true },
                { url: "/system/C4bgtspcdpstmng"         , name: "수입 결의서"       , el: <BgtSpcDpstMng          systemCode="C4" />, isVisible: true },
                { url: "/system/C4bgtspcexpndrsdocmng"   , name: "지출 결의서"       , el: <BgtSpcExpndRsdocMng    systemCode="C4" />, isVisible: true },
                { url: "/system/C4bgtspcexpndsubrsdocmng", name: "여입/추가 자료제출", el: <BgtSpcExpndSubRsdocMng systemCode="C4" />, isVisible: true },
                { url: "/system/C4bgtspcatrzrtso"        , name: "결재 상신"         , el: <BgtSpcAtrzRtso         systemCode="C4" />, isVisible: true },
                { url: "/system/C4bgtspcwholinq"         , name: "전체 조회"         , el: <BgtSpcWholinq          systemCode="C4" />, isVisible: true },
                { url: "/system/C4bgtspcdpstimplinq"     , name: "결재완료 조회"     , el: <BgtSpcDpstImplInq      systemCode="C4" />, isVisible: true },
            ]
        },
        // 6.3 희생자부조금(C4) - 통계
        {
            url: "/system/C4statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C4"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C4statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C4" />, isVisible: true },
                { url: "/system/C4statsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C4"/>, isVisible: true },
                { url: "/system/C4cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C4"/>, isVisible: true },
                { url: "/system/C4cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C4"/>, isVisible: true },
            ]
        },
        // 6.4 희생자부조금(C4) - 조합비 결재자 관리
        {
            url: "/system/C4sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["C4"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C4sysaprvrmng2", name: "조합비 결재자 관리", el: <SysAprvrMng2 />, isVisible: true },
            ]
        },
        // 6.5 희생자부조금(C4) - 희생자부조금 조회
        {
            url: "/system/C4bgtspcdpstimplinq/view",
            name: "희생자부조금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["C4"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C4bgtspcdpstimplinq/view", name: "결재완료 조회", el: <BgtSpcDpstImplInq systemCode="C4"/>, isVisible: true },
            ]
        },
        // 6.6 희생자부조금(C4) - 시스템 관리자
        {
            url: "/system/C4sysspcbgtsbjctmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["C4"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C4sysspcbgtsbjctmng/mng", name: "특별회계기금 예산과목", el: <SysSpcBgtSbjctMng />, isVisible: true },
                { url: "/system/C4sysognzmng/mng"       , name: "본부 및 지부 관리"    , el: <SysOgnzMng        />, isVisible: true },
                { url: "/system/C4sysognzinq/mng"       , name: "본부 및 지부 조회"    , el: <SysOgnzInq        />, isVisible: true },
                { url: "/system/C4sysaprvrmng2/mng"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
                { url: "/system/C4sysacntgyearmng/mng"  , name: "회계연도 관리"        , el: <SysAcntgYearMng   />, isVisible: true },
                { url: "/system/C4sysognzauthrtmng/mng" , name: "조직시스템 권한 관리" , el: <SysOgnzAuthrtMng  />, isVisible: true },
            ]
        },

        // 조합비 관리자 + 본부 관리자 메뉴 : 회원관리, 퇴직급여충당금, 시스템 관리
        // 조합비 관리자 메뉴               : 퇴직급여충당금, 시스템 관리
        // 조합비 조회자 메뉴               : 퇴직급여충당금 조회
        // 7. 퇴직급여충당금(C5)
        // 7.1 퇴직급여충당금(C5) - 회원관리
        {
            url: "/system/C5mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["C5"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C5mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/C5mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 7.2 퇴직급여충당금(C5) - 희생자부조금
        {
            url: "/system/C5bgtspcbgtfrmt",
            name: "퇴직급여충당금",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C5"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C5bgtspcbgtfrmt"         , name: "예산 편성"         , el: <BgtSpcBgtFrmt          systemCode="C5" />, isVisible: true },
                { url: "/system/C5bgtspcdpstmng"         , name: "수입 결의서"       , el: <BgtSpcDpstMng          systemCode="C5" />, isVisible: true },
                { url: "/system/C5bgtspcexpndrsdocmng"   , name: "지출 결의서"       , el: <BgtSpcExpndRsdocMng    systemCode="C5" />, isVisible: true },
                { url: "/system/C5bgtspcexpndsubrsdocmng", name: "여입/추가 자료제출", el: <BgtSpcExpndSubRsdocMng systemCode="C5" />, isVisible: true },
                { url: "/system/C5bgtspcatrzrtso"        , name: "결재 상신"         , el: <BgtSpcAtrzRtso         systemCode="C5" />, isVisible: true },
                { url: "/system/C5bgtspcwholinq"         , name: "전체 조회"         , el: <BgtSpcWholinq          systemCode="C5" />, isVisible: true },
                { url: "/system/C5bgtspcdpstimplinq"     , name: "결재완료 조회"     , el: <BgtSpcDpstImplInq      systemCode="C5" />, isVisible: true },
            ]
        },
        // 7.3 퇴직급여충당금(C5) - 통계
        {
            url: "/system/C5statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["C5"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C5statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C5" />, isVisible: true },
                { url: "/system/C5statsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq systemCode="C5"   />, isVisible: true },
                { url: "/system/C5cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C5"/>, isVisible: true },
                { url: "/system/C5cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C5"/>, isVisible: true },
            ]
        },
        // 7.4 퇴직급여충당금(C5) - 조합비 결재자 관리
        {
            url: "/system/C5sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["C5"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C5sysaprvrmng2"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
            ]
        },
        // 7.5 퇴직급여충당금(C5) - 퇴직급여충당금 조회
        {
            url: "/system/C5bgtspcdpstimplinq/view",
            name: "퇴직급여충당금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER", "BUDGET_VIEWER"],
            allowedSystem: ["C5"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C5bgtspcdpstimplinq/view", name: "결재완료 조회", el: <BgtSpcDpstImplInq systemCode="C5"/>, isVisible: true },
            ]
        },
        // 7.6 퇴직급여충당금(C5) - 시스템 관리자
        {
            url: "/system/C5sysspcbgtsbjctmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["C5"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/C5sysspcbgtsbjctmng/mng", name: "특별회계기금 예산과목", el: <SysSpcBgtSbjctMng />, isVisible: true },
                { url: "/system/C5sysognzmng/mng"       , name: "본부 및 지부 관리"    , el: <SysOgnzMng        />, isVisible: true },
                { url: "/system/C5sysognzinq/mng"       , name: "본부 및 지부 조회"    , el: <SysOgnzInq        />, isVisible: true },
                { url: "/system/C5sysaprvrmng2/mng"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
                { url: "/system/C5sysacntgyearmng/mng"  , name: "회계연도 관리"        , el: <SysAcntgYearMng   />, isVisible: true },
                { url: "/system/C5sysognzauthrtmng/mng" , name: "조직시스템 권한 관리" , el: <SysOgnzAuthrtMng  />, isVisible: true },
            ]
        },


        // 조합원 관리자 + 본부 관리자 메뉴 : 회원관리, 조합원, 시스템 관리
        // 조합원 관리자 메뉴               : 조합원, 시스템 관리
        // 조합원 결재자 메뉴               : 결재함, 조합원 조회
        // 조합원 조회자 메뉴               : 조합원 조회
        // 8. 조합원(D1)
        // 8.1 조합원(D1) - 회원관리
        {
            url: "/system/D1mbraprvmng",
            name: "회원 관리",
            iconClass: "icon2",
            isVisible: true,
            allowedRoles: ["HEAD_OFFICE_ADMIN", "SYSTEM_ADMIN"], // 사용자 권한 - LeftMenu에서 사용자 권한 체크
            allowedSystem: ["D1"],
            allowedSubSystem: ["D"],
            subMenuList: [
                { url: "/system/D1mbraprvmng", name: "회원가입 승인", el: <MbrAprvMng />, isVisible: true },
                { url: "/system/D1mbrmng"    , name: "회원 관리"    , el: <MbrMng />    , isVisible: true },
            ]
        },
        // 8.2 조합원(D1) - 조합원
        {
            url: "/system/D1mbrasnewmng",
            name: "조합원 관리",
            iconClass: "icon5",
            allowedRoles: ["MEMBER_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["D1"],
            allowedSubSystem: ["D"],
            isVisible: true,
            subMenuList: [
                { url: "/system/D1mbrasnewmng"      , name: "조합원 등록", el: <MbrasNewMng       />, isVisible: true },
                { url: "/system/D1mbraschangemng"   , name: "변경 등록"  , el: <MbrasChangeMng    />, isVisible: true },
                { url: "/system/D1mbraswhdwlmng"    , name: "탈퇴 등록"  , el: <MbrasWhdwlMng     />, isVisible: true },
                { url: "/system/D1mbrasatrzrtso"    , name: "결재 상신"  , el: <MbrasAtrzRtso     />, isVisible: true },
                { url: "/system/D1mbrasatrzprgrsinq", name: "결재 진행"  , el: <MbrasAtrzPrgrsinq />, isVisible: true },
                { url: "/system/D1mbrasinq"         , name: "조합원 조회", el: <Mbrasinq          />, isVisible: true },
                { url: "/system/D1mbrasperiodstats" , name: "조합원 통계", el: <MbrasPeriodStats  />, isVisible: true },
                { url: "/system/D1mbrasexistingmng" , name: "누락된 조합원 등록", el: <MbrasExistingMng />, isVisible: true, headOfficeOnly: true },
            ]
        },
        // 8.3 조합원(D1) - 시스템 관리
        {
            url: "/system/D1sysognzmng",
            name: "시스템 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["MEMBER_ADMIN"],
            allowedSystem: ["D1"],
            allowedSubSystem: ["D"],
            subMenuList: [
                { url: "/system/D1sysognzmng"  , name: "본부 및 지부 관리"    , el: <SysOgnzMng       />, isVisible: true },
                { url: "/system/D1sysmbrasaprvrmng", name: "조합원 결재자 관리"   , el: <SysMbrasAprvrMng  />, isVisible: true },
            ]
        },
        // 8.5 조합원(D1) - 조합원 조회
        {
            url: "/system/D1mbrasinq/view",
            name: "조합원 조회",
            iconClass: "icon5",
            allowedRoles: ["MEMBER_APPROVER", "MEMBER_VIEWER"],
            allowedSystem: ["D1"],
            allowedSubSystem: ["D"],
            isVisible: true,
            subMenuList: [
                { url: "/system/D1mbrasinq/view", name: "조합원 조회", el: <Mbrasinq />, isVisible: true },
            ]
        },
        // 8.7 조합원(D1) - 시스템 관리자
        {
            url: "/system/D1sysognzmng/mng",
            name: "시스템 관리자(ADMIN)",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["SYSTEM_ADMIN"],
            allowedSystem: ["D1"],
            allowedSubSystem: ["D"],
            subMenuList: [
                { url: "/system/D1sysognzmng/mng"      , name: "본부 및 지부 관리"    , el: <SysOgnzMng       />, isVisible: true },
                { url: "/system/D1sysognzinq/mng"      , name: "본부 및 지부 조회"    , el: <SysOgnzInq       />, isVisible: true },
                { url: "/system/D1sysmbrasaprvrmng/mng", name: "조합원 결재자 관리"   , el: <SysMbrasAprvrMng />, isVisible: true },
                { url: "/system/D1sysognzauthrtmng/mng", name: "조직시스템 권한 관리" , el: <SysOgnzAuthrtMng />, isVisible: true },
            ]
        },

        // 9. 지부운영비(E1)
        // 9.1 지부운영비(E1) - 지부운영비
        {
			url: "/system/E1bgtbrexpndrsdocmng",
			name: "지부 운영비 관리",
			iconClass: "icon5",
			isVisible: true,
			allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
			allowedSystem: ["E1"],
			allowedSubSystem: ["E"],
			subMenuList: [
				{ url: "/system/E1bgtbrdpstmng",          name: "수입 결의서"       , el: <BgtBrDpstMng           systemCode="E1" />,    isVisible: true },
				{ url: "/system/E1bgtbrexpndrsdocmng",    name: "지출 결의서"		  , el: <BgtBrExpndRsdocMng      systemCode="E1" />,    isVisible: true }, 
				{ url: "/system/E1bgtbrexpndsubrsdocmng", name: "여입/추가 자료제출" , el: <BgtBrExpndSubRsdocMng  systemCode="E1" />,     isVisible: true },
				{ url: "/system/E1bgtbratrzrtso",         name: "결재 상신"        , el: <BgtBrAtrzRtso           systemCode="E1" />,     isVisible: true },
				{ url: "/system/E1bgtbrwholinq",          name: "전체 조회"        , el: <BgtBrWholInq            systemCode="E1" />,     isVisible: true },
				{ url: "/system/E1bgtbrdpstimplinq",      name: "결재완료 조회"	  , el: <BgtBrDpstImplInq        systemCode="E1" />,     isVisible: true }, 
			]
		},

        // 9.2 지부 운영비(E1) - 통계
        {
            url: "/system/E1statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["E1"],
            allowedSubSystem: ["E"],
            subMenuList: [
                { url: "/system/E1statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="E1" />, isVisible: true },
                { url: "/system/E1cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="E1"/>, isVisible: true },
                { url: "/system/E1cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="E1"/>, isVisible: true },
            ]
        },

        // 9.3 지부 운영비(E1) - 결재자관리
        {
            url: "/system/E1sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["E1"],
            allowedSubSystem: ["E"],
            subMenuList: [
                { url: "/system/E1sysaprvrmng2"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
            ]
        },

        // 9.4 지부 운영비(E1) - 조회자 조회
        {
            url: "/system/E1bgtbrdpstimplinq/view",
            name: "지부 운영비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["E1"],
            allowedSubSystem: ["E"],
            subMenuList: [
                { url: "/system/E1bgtbrdpstimplinq/view", name: "결재완료 조회",   el: <BgtBrDpstImplInq        systemCode="E1" />,     isVisible: true }, 
            ]
        },

        // 10. 지부장 직무활동비(F1)
        // 10.1 지부장 직무활동비(F1) - 지부장 직무활동비
        {
			url: "/system/F1bgtbrexpndrsdocmng",
			name: "지부장 직무활동비 관리",
			iconClass: "icon5",
			isVisible: true,
			allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
			allowedSystem: ["F1"],
			allowedSubSystem: ["F"],
			subMenuList: [
				{ url: "/system/F1bgtbrdpstmng",          name: "수입 결의서"       , el: <BgtBrDpstMng           systemCode="F1" />,    isVisible: true },
				{ url: "/system/F1bgtbrexpndrsdocmng",    name: "지출 결의서"		  , el: <BgtBrExpndRsdocMng      systemCode="F1" />,    isVisible: true }, 
				{ url: "/system/F1bgtbrexpndsubrsdocmng", name: "여입/추가 자료제출" , el: <BgtBrExpndSubRsdocMng  systemCode="F1" />,     isVisible: true },
				{ url: "/system/F1bgtbratrzrtso",         name: "결재 상신"        , el: <BgtBrAtrzRtso           systemCode="F1" />,     isVisible: true },
				{ url: "/system/F1bgtbrwholinq",          name: "전체 조회"        , el: <BgtBrWholInq            systemCode="F1" />,     isVisible: true },
				{ url: "/system/F1bgtbrdpstimplinq",      name: "결재완료 조회"	  , el: <BgtBrDpstImplInq        systemCode="F1" />,     isVisible: true }, 
			]
		},

        // 10.2 지부장 직무활동비(F1) - 통계
        {
            url: "/system/F1statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["F1"],
            allowedSubSystem: ["F"],
            subMenuList: [
                { url: "/system/F1statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="F1" />, isVisible: true },
                { url: "/system/F1cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="F1"/>, isVisible: true },
                { url: "/system/F1cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="F1"/>, isVisible: true },
            ]
        },

        // 10.3 지부장 직무활동비(F1) - 결재자관리
        {
            url: "/system/F1sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["F1"],
            allowedSubSystem: ["F"],
            subMenuList: [
                { url: "/system/F1sysaprvrmng2"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
            ]
        },

        // 10.4 지부장 직무활동비(F1) - 조회자 조회
        {
            url: "/system/F1bgtbrdpstimplinq/view",
            name: "지부장 직무활동비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["F1"],
            allowedSubSystem: ["F"],
            subMenuList: [
                { url: "/system/F1bgtbrdpstimplinq/view", name: "결재완료 조회",   el: <BgtBrDpstImplInq        systemCode="F1" />,     isVisible: true }, 
            ]
        },

        // 11. 지부대회비(G1)
        // 11.1 지부대회비(G1) - 지부대회비(G1)
        {
			url: "/system/G1bgtbrexpndrsdocmng",
			name: "지부 대회비 관리",
			iconClass: "icon5",
			isVisible: true,
			allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
			allowedSystem: ["G1"],
			allowedSubSystem: ["G"],
			subMenuList: [
				{ url: "/system/G1bgtbrdpstmng",          name: "수입 결의서"       , el: <BgtBrDpstMng           systemCode="G1" />,    isVisible: true },
				{ url: "/system/G1bgtbrexpndrsdocmng",    name: "지출 결의서"		  , el: <BgtBrExpndRsdocMng      systemCode="G1" />,    isVisible: true }, 
				{ url: "/system/G1bgtbrexpndsubrsdocmng", name: "여입/추가 자료제출" , el: <BgtBrExpndSubRsdocMng  systemCode="G1" />,     isVisible: true },
				{ url: "/system/G1bgtbratrzrtso",         name: "결재 상신"        , el: <BgtBrAtrzRtso           systemCode="G1" />,     isVisible: true },
				{ url: "/system/G1bgtbrwholinq",          name: "전체 조회"        , el: <BgtBrWholInq            systemCode="G1" />,     isVisible: true },
				{ url: "/system/G1bgtbrdpstimplinq",      name: "결재완료 조회"	  , el: <BgtBrDpstImplInq        systemCode="G1" />,     isVisible: true }, 
			]
		},

        // 11.2 지부대회비(G1) - 통계
        {
            url: "/system/G1statsacntgyrincmexpndinq",
            name: "통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN", "SYSTEM_ADMIN"],
            allowedSystem: ["G1"],
            allowedSubSystem: ["G"],
            subMenuList: [
                { url: "/system/G1statsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="G1" />, isVisible: true },
                { url: "/system/G1cashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="G1"/>, isVisible: true },
                { url: "/system/G1cashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="G1"/>, isVisible: true },
            ]
        },

        // 11.3 지부대회비(G1) - 결재자관리
        {
            url: "/system/G1sysaprvrmng2",
            name: "조합비 결재자 관리",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_ADMIN"],
            allowedSystem: ["G1"],
            allowedSubSystem: ["G"],
            subMenuList: [
                { url: "/system/G1sysaprvrmng2"     , name: "조합비 결재자 관리"   , el: <SysAprvrMng2      />, isVisible: true },
            ]
        },

        // 11.4 지부대회비(G1) - 조회자 조회
        {
            url: "/system/G1bgtbrdpstimplinq/view",
            name: "지부 대회비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_VIEWER"],
            allowedSystem: ["G1"],
            allowedSubSystem: ["G"],
            subMenuList: [
                { url: "/system/G1bgtbrdpstimplinq/view", name: "결재완료 조회",   el: <BgtBrDpstImplInq        systemCode="G1" />,     isVisible: true }, 
            ]
        },

        // 개발용 참고
        // {
        //     url: "/system/gridTemp",
        //     name: "템프",
        //     iconClass: "icon5",
        //     isVisible: true,
        //     allowedRoles: ["SYSTEM_ADMIN"],
        //     allowedSystem: ["A1", "B1", "C1", "C2", "C3", "C4", "C5", "D1"],
        //     allowedSubSystem: ["A", "B", "C", "D"],
        //     subMenuList: [
        //         { url: "/system/gridTemp", name: "리스트 템프"    , el: <GridTemp  />, isVisible: true },
        //         { url: "/system/menu1"   , name: "메뉴 1"         , el: <Menu1     />, isVisible: true },
        //         { url: "/system/menu2"   , name: "탭"             , el: <Menu2     />, isVisible: true },
        //         { url: "/system/menu3"   , name: "첨부 파일"      , el: <Menu3     />, isVisible: true },
        //         { url: "/system/menu4"   , name: "그리드 체크박스", el: <Menu4     />, isVisible: true },
        //         { url: "/system/menu5"   , name: "조합비 첨부파일", el: <BudgetMng />, isVisible: true },
        //     ]
        // },

        /* ******************************** 결재자 메뉴 구성 *******************************/
        /* 조직 시스템 권한에 따라 메뉴 구성, 특별회계기금은 페이지 내에서 TAB으로 구성    */
        /* *********************************************************************************/
        // 1. 결재문서합(E) - 결재 문서함
        {
            url: "/system/Eatrzdocprcsmng",
            name: "결재 문서함",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER", "MEMBER_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["A", "B", "C", "D", "E", "F", "G"],
            subMenuList: [
                { url: "/system/Eatrzdocprcsmng", name: "결재 문서함", el: <AtrzDocPrcsMng />, isVisible: true },
            ]
        },

        // 2. 총괄 교부금(E) - 총괄 교부금 조회
        {
            url: "/system/Ebgtovrldpstimplinq/view",
            name: "총괄 교부금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["A"],
            subMenuList: [
                { url: "/system/Ebgtovrldpstimplinq/view" , name: "총괄교부금 조회", el: <BgtOvrlDpstImplInq  />, isVisible: true },
                { url: "/system/Ebgtovrlatrzprgrsinq/view", name: "결재진행 조회"  , el: <BgtOvrlAtrzPrgrsInq />, isVisible: true },
            ]
        },

        // 3. 운영비(E) - 운영비 조회: 결재자
        {
            url: "/system/Ebgtmbsdsdpstimplinq/view",
            name: "운영비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["B"],
            subMenuList: [
                { url: "/system/Ebgtmbsdsdpstimplinq/view" , name: "운영비 조회", el: <BgtMbsdsDpstimplinq  />, isVisible: true },
                { url: "/system/Ebgtmbsdsatrzprgrsinq/view", name: "결재진행 조회", el: <BgtMbsdsAtrzPrgrsInq />, isVisible: true },
            ]
        },

        // 4. 특별회계기금(E) - 특별회계기금 조회
        {
            url: "/system/Ebgtspcallimplinq/view",
            name: "특별회계기금 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["C"],
            subMenuList: [
                { url: "/system/Ebgtspcallimplinq/view"     , name: "특별회계기금 조회", el: <BgtSpcAllImplInq      />, isVisible: true },
                { url: "/system/Ebgtspcallatrzprgrsinq/view", name: "결재진행 조회"    , el: <BgtSpcAllAtrzPrgrsInq />, isVisible: true },
            ]
        },

        {
            url: "/system/Etotalstatsovrlmbsdsmonupognzgrnamtinq",
            name: "총괄 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["A"],
            targetSystem: "A1",
            subMenuList: [
                { url: "/system/Etotalstatsovrlmbsdsmonupognzgrnamtinq", name: "지방본부별 교부금"     , el: <StatsOvrlMbsdsMonUpOgnzGrnamtInq />, isVisible: true },
                { url: "/system/Etotalstatsovrlmbsdsmongrnamtinq"      , name: "월별 전체 교부금"      , el: <StatsOvrlMbsdsMonGrnamtInq       />, isVisible: true },
                { url: "/system/Etotalstatsovrlmbsdsgrnamtinq"         , name: "월별/지방본부별 교부금", el: <StatsOvrlMbsdsGrnamtInq          />, isVisible: true },
            ]
        },

        {
            url: "/system/Eoperatingstatsacntgyrincmexpndinq",
            name: "운영비 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["B"],
            targetSystem: "B1",
            subMenuList: [
                { url: "/system/Eoperatingstatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsAcntgYrIncmExpndInq />, isVisible: true },
                { url: "/system/Eoperatingstatsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="01"/>, isVisible: true },
                { url: "/system/Eoperatingcashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              />, isVisible: true },
                { url: "/system/Eoperatingcashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       />, isVisible: true },
            ]
        },

        {
            url: "/system/Ewelfarestatsacntgyrincmexpndinq",
            name: "복지기금 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["C"],
            targetSystem: "C1",
            subMenuList: [
                { url: "/system/Ewelfarestatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C1"/>, isVisible: true },
                { url: "/system/Ewelfarestatsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C1"/>, isVisible: true },
                { url: "/system/Ewelfarecashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C1"/>, isVisible: true },
                { url: "/system/Ewelfarecashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C1"/>, isVisible: true },
            ]
        },

        {
            url: "/system/Eindependencestatsacntgyrincmexpndinq",
            name: "자립기금 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["C"],
            targetSystem: "C2",
            subMenuList: [
                { url: "/system/Eindependencestatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C2"/>, isVisible: true },
                { url: "/system/Eindependencestatsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C2"/>, isVisible: true },
                { url: "/system/Eindependencecashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C2"/>, isVisible: true },
                { url: "/system/Eindependencecashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C2"/>, isVisible: true },
            ]
        },

        {
            url: "/system/Edevelopmentstatsacntgyrincmexpndinq",
            name: "발전기금 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["C"],
            targetSystem: "C3",
            subMenuList: [
                { url: "/system/Edevelopmentstatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C3" />, isVisible: true },
                { url: "/system/Edevelopmentstatsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C3"/>, isVisible: true },
                { url: "/system/Edevelopmentcashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C3"/>, isVisible: true },
                { url: "/system/Edevelopmentcashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C3"/>, isVisible: true },
            ]
        },

        {
            url: "/system/Ereliefstatsacntgyrincmexpndinq",
            name: "희생자부조금 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["C"],
            targetSystem: "C4",
            subMenuList: [
                { url: "/system/Ereliefstatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C4" />, isVisible: true },
                { url: "/system/Ereliefstatsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq    systemCode="C4"/>, isVisible: true },
                { url: "/system/Ereliefcashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C4"/>, isVisible: true },
                { url: "/system/Ereliefcashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C4"/>, isVisible: true },
            ]
        },

        {
            url: "/system/Eretirementstatsacntgyrincmexpndinq",
            name: "퇴직급여충당금 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["C"],
            targetSystem: "C5",
            subMenuList: [
                { url: "/system/Eretirementstatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="C5" />, isVisible: true },
                { url: "/system/Eretirementstatsacntgyruseamtinq"   , name: (<>관,항,목별 집행현황 <br /> (시산표)</>), el: <StatsAcntgYrUseAmtInq systemCode="C5"   />, isVisible: true },
                { url: "/system/Eretirementcashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="C5"/>, isVisible: true },
                { url: "/system/Eretirementcashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="C5"/>, isVisible: true },
            ]
        },

        // 5 지부 운영비(E) - 지부 운영비 조회
		{
            url: "/system/Ebgtbrdpstimplinq/Eview",
            name: "지부 운영비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["E"],
            subMenuList: [
                { url: "/system/Ebgtbrdpstimplinq/Eview"    , name: "지부 운영비 조회", el: <BgtBrDpstImplInq        systemCode="E1" />,     isVisible: true }, 
                { url: "/system/Ebgtbrallatrzprgrsinq/Eview", name: "결재진행 조회",   el: <BgtBrAllAtrzPrgrsInq     systemCode="E1" />,     isVisible: true }, 
            ]
        },

        // 6 지부장 직무활동비(E) - 지부장 직무활동비 조회
		{
            url: "/system/Ebgtbrdpstimplinq/Fview",
            name: "지부장 직무활동비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["F"],
            subMenuList: [
                { url: "/system/Ebgtbrdpstimplinq/Fview"    , name: "지부장 직무활동비 조회", el: <BgtBrDpstImplInq     systemCode="F1" />,     isVisible: true }, 
                { url: "/system/Ebgtbrallatrzprgrsinq/Fview", name: "결재진행 조회",         el: <BgtBrAllAtrzPrgrsInq systemCode="F1" />,     isVisible: true }, 
            ]
        },

        // 7 지부 대회비(E) - 지부 대회비 조회
		{
            url: "/system/Ebgtbrdpstimplinq/Gview",
            name: "지부 대회비 조회",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["G"],
            subMenuList: [
                { url: "/system/Ebgtbrdpstimplinq/Gview"    , name: "지부 대회비 조회", el: <BgtBrDpstImplInq        systemCode="G1" />,     isVisible: true }, 
                { url: "/system/Ebgtbrallatrzprgrsinq/Gview", name: "결재진행 조회",   el: <BgtBrAllAtrzPrgrsInq     systemCode="G1" />,     isVisible: true }, 
            ]
        },
        
        {
            url: "/system/Ebranchstatsacntgyrincmexpndinq",
            name: "지부 운영비 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["E"],
            targetSystem: "E1",
            subMenuList: [
                { url: "/system/Ebranchstatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="E1" />, isVisible: true },
                { url: "/system/Ebranchcashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="E1"/>, isVisible: true },
                { url: "/system/Ebranchcashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="E1"/>, isVisible: true },
            ]
        },

        {
            url: "/system/Echiefstatsacntgyrincmexpndinq",
            name: "지부장 직무활동비 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["F"],
            targetSystem: "F1",
            subMenuList: [
                { url: "/system/Echiefstatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="F1" />, isVisible: true },
                { url: "/system/Echiefcashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="F1"/>, isVisible: true },
                { url: "/system/Echiefcashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="F1"/>, isVisible: true },
            ]
        },

        {
            url: "/system/Eeventstatsacntgyrincmexpndinq",
            name: "지부 대회비 통계",
            iconClass: "icon5",
            isVisible: true,
            allowedRoles: ["BUDGET_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["G"],
            targetSystem: "G1",
            subMenuList: [
                { url: "/system/Eeventstatsacntgyrincmexpndinq", name: "회계연도 수입/지출", el: <StatsSpcAcntgYrIncmExpndInq systemCode="G1" />, isVisible: true },
                { url: "/system/Eeventcashbookmng"             , name: "현금 출납부"       , el: <CashBookMng              systemCode="G1"/>, isVisible: true },
                { url: "/system/Eeventcashexpensebookmng"      , name: "현금 지출부"       , el: <CashExpenseBookMng       systemCode="G1"/>, isVisible: true },
            ]
        },

        // 8 조합원(E) - 조합원 조회
        {
            url: "/system/Embrasinq/view",
            name: "조합원 조회",
            iconClass: "icon5",
            allowedRoles: ["MEMBER_APPROVER"],
            allowedSystem: ["E"],
            allowedSubSystem: ["D"],
            isVisible: true,
            subMenuList: [
                { url: "/system/Embrasinq/view",     name: "조합원 조회", el: <Mbrasinq />, isVisible: true },
                { url: "/system/Embrasatrzprgrsinq", name: "결재진행 조회"  , el: <MbrasAtrzPrgrsinq />, isVisible: true },
            ]
        },
    ] as systemMenuProps[],
    getAdminMenuPath: (url: string) => {
        let path: string = "";
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                if (url.indexOf(subMenuInfo.url) !== -1) {
                    path = menuInfo.url;
                    return;
                }
            });
        });
        return path;
    },
    getAdminMenuName: (url: string) => {
        let menuName: string = "";
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                if (url.indexOf(subMenuInfo.url) !== -1) {
                    menuName = menuInfo.name;
                    return;
                }
            });
        });
        return menuName;
    },
    getAdminSubMenuPath: (url: string) => {
        let path: string = "";
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                if (url.indexOf(subMenuInfo.url) !== -1) {
                    path = subMenuInfo.url;
                    return;
                }
            });
        });
        return path;
    },
    getAdminSubMenuName: (url: string) => {
        let menuName: string = "";
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                if (url.indexOf(subMenuInfo.url) !== -1) {
                    menuName = subMenuInfo.name;
                    return;
                }
            });
        });
        return menuName;
    },
    getAdminSubMenuDetailName: (url: string) => {
        let menuName: string = "";
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                subMenuInfo.detailMenuList?.forEach(detailMenuList => {
                    const tempUrl = detailMenuList.url.split(':')[0];
                    if (url.indexOf(tempUrl) !== -1) {
                        menuName = detailMenuList.name;
                        return;
                    }
                })
            });
        });
        return menuName;
    },
    getSubMenuList: (url: string) => {
        let subMenuList: any[] = [];
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                if (subMenuInfo.url === url) {
                    subMenuList = menuInfo.subMenuList;
                }
            });
        });
        return subMenuList;
    },
    getMainMenuUrlBySubMenuUrl: (subMenuUrl: string) => {
        let mainMenuUrl: string = "";
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                if (subMenuInfo.url === subMenuUrl) {
                    mainMenuUrl = menuInfo.url;
                }
            });
        });
        return mainMenuUrl;
    },
    getMainMenuUrlByDetailMenuUrl: (detailMenuUrl: string) => {
        let mainMenuUrl: string = "";
        SystemMenu.menuList.forEach((menuInfo) => {
            menuInfo.subMenuList?.forEach((subMenuInfo) => {
                subMenuInfo.detailMenuList?.forEach(detailMenuList => {
                    const tempUrl = detailMenuList.url.split(':')[0];
                    if (detailMenuUrl.indexOf(tempUrl) !== -1) {
                        mainMenuUrl = menuInfo.url;
                        return;
                    }
                })
            });
        });
        return mainMenuUrl;
    }
}
export default SystemMenu;